import { Controller } from "@hotwired/stimulus"

import select2 from "select2"

export default class extends Controller {
  connect() {
    select2();
    $('.select2-container').remove();
    $('.select2-single').select2({
      placeholder: 'Auswählen',
      closeOnSelect: true,
      language: {
        noResults: function() {
          return 'Nichts gefunden...';
        },
      },
    });
  }
}
